<template>
  <div class="container ">

      <div class="card" >
    <!--<img src="..." class="card-img-top" alt="...">-->
    <div class="card-body">
        <h5 class="card-title">Agregar Auto</h5>
        <form class="text-left">
            <div class="form-group">
                <label class='etiquetaLabel' for="patente">Patente</label><br/>
                <input type="text" class="etiqueta" v-model='patente' readonly maxlength="6" minlength="6" size="8">  
            </div>

            <div class="form-group">
                <label class='etiquetaLabel' for="tipo">Seleccione</label><br/>
                <select v-model="residente" @change.prevent="reside" class="etiqueta">
                    <option disabled value="">Seleccione</option>
                    <option>Residente</option>
                    <option>Visitante</option>
                    <option>Servicios</option>
                    <option>Delivery</option>
                </select>
            </div>
            
            <div class="form-group">
                <label class='etiquetaLabel' for="numerodepartamento">Depto</label><br/>
                <input id='numerodepartamento' type="number" class="etiqueta" v-model.number="numerodepartamento" min='1000' max="2299"  size="4" maxlength="4">           
            </div>
            <div class="form-group">
                <label class='etiquetaLabel' for="nombre">Nombre</label>
                <input id='nombre' type="text" class="etiqueta" v-model="nombre" size="15" maxlength="20" >           
            </div>
            <div class="form-group">                        
                <label class='etiquetaLabel' for="marca">Marca   </label><br/>
                <select v-model="marca" class="etiqueta">
                    <option v-for="(option,index) in traerdatamarcas" v-bind:value="option.nombremarca" :key="index">
                        {{ option.nombremarca }}
                    </option>
                </select>               
            </div>
            <div class="my-5">
                    <button type="button" class="btn btn-primary btn-block my-3" @click.prevent="saveCar">Save </button>
                    <button type="button" class="btn btn-secondary btn-block my-3" @click.prevent="volver"  >Close</button>
            </div>

        </form>
  </div>
</div>



         
      
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name:'CarAdd',
    data(){
        return{            
            residente:'Residente',
            nombre:'Residente',
            numerodepartamento:9999,
            marca:'',
            patente: ''
        }
    },
    computed:{
        traerdatamarcas(){
            return this.$store.getters.enviardatamarcas;
        }
    },
    created(){
        this.patente = this.$route.params.id;
    },
    methods:{
        volver(){
            this.$router.push('/');
        },
        reside(){    
            if(this.residente==='Residente'){
                this.nombre='Residente'
                this.numerodepartamento=9999
            } else if(this.residente==='Servicios'){
                this.nombre='Servicios';
                this.numerodepartamento=''
                document.getElementById("numerodepartamento").focus();
            } else if(this.residente==='Delivery'){
                this.nombre='Delivery';
                this.numerodepartamento=''
                document.getElementById("numerodepartamento").focus();
            }else {
                this.nombre=''                
                this.numerodepartamento=''
                document.getElementById("numerodepartamento").focus();
            }
        },
        saveCar(){
            console.log("entramos a grabar ")
            if(this.numerodepartamento && this.residente && this.nombre && this.marca){
                let auxiliar={
                    patente:this.patente.toUpperCase(),
                    residente:this.residente.toUpperCase(),
                    numerodepartamento:this.numerodepartamento,
                    nombre:this.nombre.toUpperCase(),
                    marca:this.marca,                
                }
                this.$store.dispatch('saveCar',auxiliar);                                 
                this.$router.push('/');
                
            }else{
                Swal.fire("Escriba datos")                 
            }
            this.residente='Residente';
            this.numerodepartamento=9999;
            this.nombre='';
            this.marca='';

        }
    }
}
</script>

<style scoped>


</style>